import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Modal } from '@shared/ui/Overlays/Modal'
import s from './Modals.module.sass'
import Img from '@images/restorator/main-feature.webp'
import Image from 'next/image'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  active: boolean
  onClose: () => void
}

export const MainFeatureModal = ({ active, onClose }: Props) => {
  return (
    <>
      {active && (
        <BlockBoundary>
          <Modal
            title='Фичер на главной'
            handleClose={onClose}
            size='S'
            titleSizes='h1 h3'
            className={s.bottomless}
            mobileShadowless={true}>
            <div className={s.content}>
              <Text sizes='ML M' className={s['text-content']}>
                <span>
                  Демонстрация карточки ресторана в слайдере на&nbsp;главной странице «Афиши Рестораны» в&nbsp;городе
                  заведения
                </span>
              </Text>

              <Image src={Img.src} alt='Промо' width={255} height={406} quality={100} />
            </div>
          </Modal>
        </BlockBoundary>
      )}
    </>
  )
}
